import { render, staticRenderFns } from "./SelectItemsModal.vue?vue&type=template&id=008f1d35"
import script from "./SelectItemsModal.vue?vue&type=script&lang=js"
export * from "./SelectItemsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports